<script>
    import Vue from 'vue';

    export default Vue.component('ExpandableList', {
        props: {
            defaultPageSize: {
                type: Number,
                default: 5,
            },
        },
        data() {
            return {
                page: 1,
            };
        },
        computed: {
            visibleItemsCount() {
                return this.$props.defaultPageSize * this.page;
            },
        },
        methods: {
            showMore() {
                this.page += 1;
            }
        },
        render(createElement) {
            let expandButton;
            if (this.$slots.default.length > this.visibleItemsCount) {
                expandButton = createElement(
                    'button',
                    { class: 'btn', on: { click: this.showMore } },
                    this.$t('show more').toUpperCase(),
                );
            }
            const visibleChildren = this.$slots.default.slice(0, this.visibleItemsCount);
            return createElement(
                'div',
                [createElement(
                    'ul',
                    [
                        ...visibleChildren,
                        expandButton,
                    ],
                )],
            );
        },
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/ExpandableList.vue